import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dab2961"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_solo_case_selector = _resolveComponent("app-solo-case-selector")!

  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: _ctx.loaderText
            }, {
              default: _withCtx(() => [
                (_ctx.isLoading && _ctx.uploadInfo.total)
                  ? (_openBlock(), _createBlock(_component_app_upload_info, {
                      key: 0,
                      "upload-info": _ctx.uploadInfo,
                      onCancelUpload: _ctx.cancelUpload
                    }, null, 8, ["upload-info", "onCancelUpload"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true),
        _createVNode(_component_app_solo_case_selector, {
          onDone: _ctx.handleSelect,
          onCancel: _ctx.onCancel
        }, null, 8, ["onDone", "onCancel"])
      ]))
    : _createCommentVNode("", true)
}